export class TaxIdValidationUtil {
    /**
     * Valida CNPJ (padrão tradicional numérico ou novo padrão alfanumérico).
     * @param {string} cnpj
     * @returns {boolean}
     */
    static isValidCNPJ(cnpj) {
        if (!cnpj || typeof cnpj !== 'string') return false;

        const cleanValue = cnpj.replace(/[^\w]/g, '').toUpperCase();

        // CNPJ deve ter exatamente 14 caracteres alfanuméricos
        if (cleanValue.length !== 14) return false;

        // Bloqueia sequências de caracteres idênticos (ex: "AAAAAAAAAAAAAA")
        if (/^(\w)\1+$/.test(cleanValue)) return false;

        // Os dois últimos caracteres (DVs) continuam sendo estritamente numéricos
        if (!/^\d{2}$/.test(cleanValue.slice(-2))) return false;

        const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

        const dv1 = TaxIdValidationUtil.#calculateCnpjDV(cleanValue, 12, weights1);
        const dv2 = TaxIdValidationUtil.#calculateCnpjDV(cleanValue, 13, weights2);

        return dv1 === parseInt(cleanValue[12], 10) && dv2 === parseInt(cleanValue[13], 10);
    }

    /**
     * Valida CPF tradicional.
     * @param {string} cpf
     * @returns {boolean}
     */
    static isValidCPF(cpf) {
        if (!cpf || typeof cpf !== 'string') return false;

        const cleanValue = cpf.replace(/\D/g, '');

        if (cleanValue.length !== 11) return false;
        if (/^(\d)\1+$/.test(cleanValue)) return false;

        const dv1 = TaxIdValidationUtil.#calculateCpfDV(cleanValue, 9);
        const dv2 = TaxIdValidationUtil.#calculateCpfDV(cleanValue, 10);

        return dv1 === parseInt(cleanValue[9], 10) && dv2 === parseInt(cleanValue[10], 10);
    }

    /**
     * Validador genérico: identifica se é CPF (11 dígitos) ou CNPJ (14 caracteres).
     * @param {string} value
     * @returns {boolean}
     */
    static isValid(value) {
        if (!value || typeof value !== 'string') return false;

        const cleanValue = value.replace(/[^\w]/g, '');

        if (cleanValue.length === 11) {
            return TaxIdValidationUtil.isValidCPF(cleanValue);
        }

        if (cleanValue.length === 14) {
            return TaxIdValidationUtil.isValidCNPJ(cleanValue);
        }

        return false;
    }

    // --- Métodos Privados de Suporte ---

    static #calculateCnpjDV(cnpjStr, sliceLength, weights) {
        const sum = cnpjStr
            .slice(0, sliceLength)
            .split('')
            .reduce((acc, char, index) => {
                // Tabela ASCII: Letras 'A'-'Z' (65-90) viram (17-42) subtraindo 48
                const val = /\d/.test(char) ? parseInt(char, 10) : char.charCodeAt(0) - 48;
                return acc + val * weights[index];
            }, 0);

        const rest = sum % 11;
        return rest < 2 ? 0 : 11 - rest;
    }

    static #calculateCpfDV(cpfStr, sliceLength) {
        let sum = 0;
        for (let i = 0; i < sliceLength; i++) {
            sum += parseInt(cpfStr[i], 10) * (sliceLength + 1 - i);
        }
        const rest = (sum * 10) % 11;
        return rest === 10 || rest === 11 ? 0 : rest;
    }
}